import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";
import { GoogleOAuthProvider } from "@react-oauth/google";

 const breakpoints = {
  sm:  "30em",  // 480 px  → small phones in landscape / small tablets
  md:  "48em",  // 768 px  → tablets / small laptops
  lg:  "1024px",  // 992 px  → typical laptop / desktop
  xl:  "1800px",  // 1280 px → large desktop
  "2xl": "96em" // 1536 px → ultra-wide monitors
};


const theme = extendTheme({
  breakpoints,
  fonts: {
    heading: "Inter, sans-serif",
    body: "Inter, sans-serif",
  },
  config: {
    initialColorMode: "light",
    useSystemColorMode: true,
  },
  colors: {
    customGreen: {
      500: "#286328",
    },
  },
  components: {
    Popover: {
      baseStyle: {
        content: {
          _focus: {
            boxShadow: "none",
          },
        },
      },
    },
    Switch: {
      baseStyle: {
        track: {
          _checked: {
            bg: "customGreen.500",
          },
        },
      },
    },
    Checkbox: {
      baseStyle: {
        control: {
          borderRadius: "none",
          borderColor: "customGreen.500",
          _checked: {
            bg: "customGreen.500",
            borderColor: "customGreen.500",
            color: "white",
          },
          _hover: {
            borderColor: "customGreen.500",
            color:"customGreen.500",
          },
          _focus: {
            boxShadow: "0 0 0 1px #286328",
          },
        },
        icon: {
          color: "white",
        },
      },
    },
  },
});

export default theme;

const container = document.getElementById("root"); // Get the container to mount your app
const root = createRoot(container); // Create a root

root.render(
  // Use the root to render your app
  <I18nextProvider i18n={i18n}>
    <ChakraProvider theme={theme}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <App />
      </GoogleOAuthProvider>
    </ChakraProvider>
  </I18nextProvider>
);
